export type KiemKeTrangThai = 'phieuTam' | 'daCanBang' | 'daHuy' | 'daXoa' | 'khac'

export type IKiemKeLine = {
  id?: string
  hangHoaId: string
  maHangHoa?: string | null
  /** Mã gốc để hiển thị (hàng cùng loại `<maGoc>-n`); không dùng cho payload. */
  hangHoaGocMa?: string | null
  tenHangHoa?: string | null
  donViTinh?: string | null
  tonKho: number
  soLuongThucTe: number | null
  soLuongLech: number
  giaVon: number
  giaTriLech: number
  serialImei?: string | null
  dateSanPham?: string | null
  lyDoKiemKe?: string | null
  ghiChu?: string | null
}

export type IKiemKe = {
  id: string
  maPhieuKiem: string
  thoiGian: string
  ngayCanBang?: string | null
  trangThai: KiemKeTrangThai
  trangThaiRaw?: string | null
  ghiChu?: string | null
  tongSlThucTe?: number | null
  tongChenhLech?: number | null
  tongGiaTriThucTe?: number | null
  slLechTang?: number | null
  slLechGiam?: number | null
  danhSachHangHoa: IKiemKeLine[]
  nguoiTaoId?: string | null
  nguoiTaoLabel?: string | null
  chiNhanhId?: string | null
  chiNhanhTen?: string | null
  phieuKhos?: Array<{
    id: string
    maPhieu: string
    loaiPhieu?: string
    huong?: string
    trangThai?: string
  }>
}

export type IKiemKeLinePayload = {
  hangHoaId: string
  soLuongThucTe?: number | null
  donViTinh?: string | null
  serialImei?: string | null
  dateSanPham?: string | null
  lyDoKiemKe?: string | null
  ghiChu?: string | null
}

export type IKiemKePayload = {
  maPhieuKiem?: string
  thoiGian?: string
  ghiChu?: string
  /** Sao chép: giữ chi nhánh phiếu gốc. Tạo mới thường bỏ trống (chi nhánh đang đứng). */
  chiNhanhId?: number
  danhSachHangHoa?: IKiemKeLinePayload[]
}

export const isKiemKeKhoaTheoTrangThai = (t: KiemKeTrangThai): boolean =>
  t === 'daCanBang' || t === 'daHuy' || t === 'daXoa'

export const normalizeKiemKeTrangThai = (raw: unknown): { trangThai: KiemKeTrangThai; trangThaiRaw: string | null } => {
  const s0 = raw != null ? String(raw) : ''
  const s = s0.trim()
  if (!s) return { trangThai: 'phieuTam', trangThaiRaw: null }
  const u = s.toLowerCase()
  if (u === 'phieutam' || u === 'phieu_tam') return { trangThai: 'phieuTam', trangThaiRaw: s0 }
  if (u === 'dacanbang' || u === 'da_can_bang') return { trangThai: 'daCanBang', trangThaiRaw: s0 }
  if (u === 'dahuy' || u === 'da_huy') return { trangThai: 'daHuy', trangThaiRaw: s0 }
  if (u === 'daxoa' || u === 'da_xoa') return { trangThai: 'daXoa', trangThaiRaw: s0 }
  return { trangThai: 'khac', trangThaiRaw: s0 }
}
